theme.headerSearch = (function () {
  function searchOverlay(e) {
    if (!e) return;
    if (e.__dyzHeaderSearchReady) return;
    e.__dyzHeaderSearchReady = true;

    var SEARCH_TRIGGER_SELECTOR = ".header__actions_btn--search";
    var SEARCH_CLOSE_SELECTOR = "#search__close_btn, [data-search-close], .dyz-mobile-search-close, .dyz-desktop-search-close";
    var SEARCH_PANEL_SELECTOR = ".search__content_inner.predictive--search-drawer-inner";
    var SEARCH_BODY_CLASS = "added__overlay_search";
    var SEARCH_VISIBLE_BODY_CLASS = "dyz-search-visible";
    var SEARCH_OPENING_CLASS = "is-opening";
    var SEARCH_CLOSING_CLASS = "is-closing";
    var SEARCH_ACTIVE_CLASS = "active";
    var SEARCH_ANIMATION_MS = 520;

    var input = e.querySelector('input[type="search"]');
    var closeTimer = null;
    var lastTrigger = null;

    function isSearchOverlayActive() {
      return e.classList.contains(SEARCH_ACTIVE_CLASS) || document.body.classList.contains(SEARCH_BODY_CLASS);
    }

    function blockSearchConfirm(event) {
      /*
        DiYoZone v8.7.17:
        Prevent the search drawer form from submitting to /search when the user
        presses Enter / Search / Return after typing in the search panel.
        This keeps desktop and mobile inside the predictive-search drawer.
        Clicking actual result links still works normally.
      */
      if (!event) return;
      if (!isSearchOverlayActive()) return;

      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      }
    }

    function setupNoSubmitSearchPanel() {
      var forms = e.querySelectorAll('form[role="search"], form.search, form.search-modal__form');
      var searchInputs = e.querySelectorAll('input[type="search"], input[name="q"]');

      forms.forEach(function (form) {
        if (!form || form.__dyzNoSubmitReady) return;
        form.__dyzNoSubmitReady = true;

        form.addEventListener("submit", blockSearchConfirm, true);
      });

      searchInputs.forEach(function (searchInput) {
        if (!searchInput || searchInput.__dyzNoSubmitReady) return;
        searchInput.__dyzNoSubmitReady = true;

        searchInput.setAttribute("enterkeyhint", "done");

        searchInput.addEventListener(
          "keydown",
          function (event) {
            if (event.key === "Enter" || event.code === "Enter" || event.keyCode === 13) {
              blockSearchConfirm(event);
            }
          },
          true
        );
      });
    }

    function isMobileSearchViewport() {
      return window.matchMedia && window.matchMedia("(max-width: 991px)").matches;
    }

    function blurSearchInput() {
      var active = document.activeElement;

      try {
        if (active && active !== document.body && e.contains(active)) {
          active.blur();
        } else if (input) {
          input.blur();
        }
      } catch (error) {}
    }

    function releasePageInteractionAfterSearchClose() {
      /*
        DiYoZone smooth scroll release:
        During the closing animation the overlay may remain visible, but the
        page itself should be scrollable immediately after close is triggered.
      */
      document.body.classList.remove(SEARCH_VISIBLE_BODY_CLASS);

      document.documentElement.style.removeProperty("overflow");
      document.documentElement.style.removeProperty("touch-action");
      document.body.style.removeProperty("overflow");
      document.body.style.removeProperty("touch-action");
    }

    function resetSearchToInitialState() {
      /*
        DiYoZone v8.7.7:
        Every time the drawer is closed / reopened, return to the initial state:
        empty input + default navigation / popular search list, no previous tabs/results.
      */
      var predictiveSearch = e.querySelector("predictive-search");
      var resultContainer = e.querySelector("[data-predictive-search]");
      var status = e.querySelector(".predictive-search-status");
      var resetButton = e.querySelector(".reset__button");

      if (input) {
        input.value = "";
        input.setAttribute("aria-expanded", "false");
      }

      if (resetButton) {
        resetButton.classList.add("hidden");
      }

      if (predictiveSearch) {
        predictiveSearch.removeAttribute("open");
        predictiveSearch.removeAttribute("loading");
        predictiveSearch.removeAttribute("results");
      }

      if (resultContainer) {
        resultContainer.removeAttribute("id");
        resultContainer.innerHTML = '<div class="predictive-search__loading-state"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>';
      }

      if (status) {
        status.textContent = "";
        status.setAttribute("aria-hidden", "true");
      }
    }

    function finalSearchCleanup() {
      document.body.classList.remove(SEARCH_VISIBLE_BODY_CLASS);
      document.body.classList.remove(SEARCH_BODY_CLASS);
      releasePageInteractionAfterSearchClose();
    }

    function getOverlay(wrapper) {
      return document.querySelector(wrapper);
    }

    function focusSearchInput() {
      if (!input) return;

      window.setTimeout(function () {
        if (!document.body.classList.contains(SEARCH_VISIBLE_BODY_CLASS)) return;

        try {
          input.focus({ preventScroll: true });
        } catch (error) {
          input.focus();
        }
      }, 140);
    }

    function callTrapFocus(overlay) {
      if (typeof trapFocus !== "function") return;

      try {
        trapFocus(overlay);
      } catch (error) {}

      if (input) {
        try {
          trapFocus(input);
        } catch (error) {}
      }
    }

    function callRemoveTrapFocus(trigger) {
      if (typeof removeTrapFocus !== "function") return;

      try {
        removeTrapFocus(trigger || lastTrigger || document.body);
      } catch (error) {}
    }

    function openSearch(overlay, trigger) {
      if (!overlay) return;

      window.clearTimeout(closeTimer);
      lastTrigger = trigger || lastTrigger;

      resetSearchToInitialState();

      overlay.classList.remove(SEARCH_CLOSING_CLASS);
      overlay.classList.add(SEARCH_ACTIVE_CLASS, SEARCH_OPENING_CLASS);
      overlay.setAttribute("aria-hidden", "false");

      document.body.classList.add(SEARCH_BODY_CLASS, SEARCH_VISIBLE_BODY_CLASS);

      window.requestAnimationFrame(function () {
        overlay.classList.add("is-visible");
        focusSearchInput();
      });

      window.setTimeout(function () {
        overlay.classList.remove(SEARCH_OPENING_CLASS);
        if (overlay.classList.contains(SEARCH_ACTIVE_CLASS) && !overlay.classList.contains(SEARCH_CLOSING_CLASS)) {
          callTrapFocus(overlay);
        }
      }, SEARCH_ANIMATION_MS);
    }

    function closeSearch(overlay, trigger) {
      if (!overlay || !overlay.classList.contains(SEARCH_ACTIVE_CLASS)) return;

      window.clearTimeout(closeTimer);

      var isMobileViewport = isMobileSearchViewport();
      var cleanupDelay = isMobileViewport ? 280 : 420;

      if (isMobileViewport) {
        blurSearchInput();
      } else {
        blurSearchInput();
      }

      resetSearchToInitialState();

      overlay.classList.remove(SEARCH_OPENING_CLASS, "is-visible");
      overlay.classList.add(SEARCH_CLOSING_CLASS);
      overlay.setAttribute("aria-hidden", "true");

      /* Release page scroll immediately. Keep overlay classes for animation only. */
      releasePageInteractionAfterSearchClose();

      window.requestAnimationFrame(releasePageInteractionAfterSearchClose);
      window.setTimeout(releasePageInteractionAfterSearchClose, 60);
      window.setTimeout(releasePageInteractionAfterSearchClose, 160);

      closeTimer = window.setTimeout(function () {
        resetSearchToInitialState();
        overlay.classList.remove(SEARCH_ACTIVE_CLASS, SEARCH_CLOSING_CLASS);
        finalSearchCleanup();
        callRemoveTrapFocus(trigger || lastTrigger);
      }, cleanupDelay);
    }

    function drawerAction(trigger, closeTrigger, wrapper) {
      var offcanvasSearchTrigger = document.querySelectorAll(trigger);
      var offcanvasSidebarSearch = getOverlay(wrapper);

      if (!offcanvasSidebarSearch || !offcanvasSearchTrigger.length) return;
      if (offcanvasSidebarSearch.__dyzSearchDrawerReady) return;
      offcanvasSidebarSearch.__dyzSearchDrawerReady = true;

      offcanvasSidebarSearch.setAttribute("aria-hidden", "true");
      setupNoSubmitSearchPanel();

      offcanvasSearchTrigger.forEach(function (singleTrigger) {
        if (!singleTrigger) return;

        singleTrigger.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();

          if (offcanvasSidebarSearch.classList.contains(SEARCH_ACTIVE_CLASS)) {
            closeSearch(offcanvasSidebarSearch, singleTrigger);
          } else {
            openSearch(offcanvasSidebarSearch, singleTrigger);
          }
        });
      });

      document.querySelectorAll(SEARCH_CLOSE_SELECTOR).forEach(function (closeButton) {
        closeButton.addEventListener("click", function (event) {
          event.preventDefault();
          closeSearch(offcanvasSidebarSearch, lastTrigger);
        });
      });

      offcanvasSidebarSearch.addEventListener("keyup", function (evt) {
        if (evt.code === "Escape" || evt.key === "Escape") {
          closeSearch(offcanvasSidebarSearch, lastTrigger);
        }
      });

      document.addEventListener("keydown", function (evt) {
        if (evt.code === "Escape" || evt.key === "Escape") {
          closeSearch(offcanvasSidebarSearch, lastTrigger);
        }
      });

      document.addEventListener("click", function (event) {
        var eventTarget = event.target;

        if (!offcanvasSidebarSearch.classList.contains(SEARCH_ACTIVE_CLASS)) return;

        if (eventTarget.closest(SEARCH_TRIGGER_SELECTOR)) return;
        if (eventTarget.closest(SEARCH_CLOSE_SELECTOR)) return;
        if (eventTarget.closest(SEARCH_PANEL_SELECTOR)) return;

        closeSearch(offcanvasSidebarSearch, lastTrigger);
      });

      offcanvasSidebarSearch.addEventListener("click", function (event) {
        if (!offcanvasSidebarSearch.classList.contains(SEARCH_ACTIVE_CLASS)) return;
        if (event.target.closest(SEARCH_PANEL_SELECTOR)) return;

        closeSearch(offcanvasSidebarSearch, lastTrigger);
      });
    }

    drawerAction(
      SEARCH_TRIGGER_SELECTOR,
      "search__close_btn",
      "#predictive__search_overlay"
    );
  }

  return searchOverlay;
})();
